export const webAppVersion = '1.2.1';

export const termsOfServiceLink = 'http://hellojoko.com/conditions-generales';
export const privacyPolicyLink = 'http://hellojoko.com/politique-confidentialite';
